<template>
  <div>
    <el-card>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>KPI考核</el-breadcrumb-item>
            <el-breadcrumb-item>额外从属关系列表</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row>
        <el-col :span="10">
          <el-row :gutter="2">
            <el-col :span="10">
                <el-input
                    size="small"
                    style="margin-bottom:10px"
                    v-model="searchName"
                    placeholder="请输入被审核人姓名"
                >
                    <el-button slot="append" icon="el-icon-search" @click="SearchByName"></el-button>
                </el-input>
            </el-col>
            <el-col :span="3">
                <el-button type="primary" size="small" @click="Refresh" plain>刷新</el-button>
            </el-col>
          </el-row>
        </el-col>
        <el-col style="text-align:right;" :span="14">
              <el-button type="primary" size="small" @click="AddTask" plain>添加</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table :data="ExtrasList" style="width: 100%" v-loading="loading" size="small">
            <el-table-column prop="Id" width="300" label="编号"></el-table-column>
            <el-table-column prop="TrueName" label="被审核人姓名"></el-table-column>
            <el-table-column prop="UserCode" label="被审核人工号"></el-table-column>
            <!-- <el-table-column prop="IsRepeat" label="审核人姓名">
                <template slot-scope="scope">
                    <span>{{ scope.row.PeriodType==1?"季度":"月度" }}</span>
                </template>
            </el-table-column> -->
            <el-table-column prop="LeadTrueName" label="审核人姓名"></el-table-column>
            <el-table-column prop="LeadUserCode" label="审核人工号"></el-table-column>
            <el-table-column prop="CreateTime"  label="添加时间"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">  
                <el-button @click="UpdateExtras(scope.row)" type="text">编辑</el-button>
                <el-popconfirm title="确定删除此条信息吗？" @onConfirm="DeleteExtras(scope.row)">
                  <el-button type="text" slot="reference" style="color:red;">删除</el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row style="text-align:right;">
          <el-col>
                <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageIndex"
                :page-sizes="pageSizes"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
                style="float:right"
                ></el-pagination>
            </el-col>
      </el-row>
      <el-dialog width="50%" :title="dialogTitle" :visible.sync="dialogVisible" top="10px">
        <el-form :model="ExtrasModel" ref="taskForm" :rules="rules">
          <el-form-item label="被审核人姓名" :label-width="formLabelWidth" prop="TrueName">
            <el-input v-model="ExtrasModel.TrueName" autocomplete="off" placeholder="请输入被审核人姓名"></el-input>
          </el-form-item>
          <el-form-item label="被审核人工号" :label-width="formLabelWidth" prop="UserCode">
            <el-input v-model="ExtrasModel.UserCode" autocomplete="off" placeholder="请输入被审核人工号"></el-input>
          </el-form-item>
          <el-form-item label="审核人姓名" :label-width="formLabelWidth" prop="LeadTrueName">
            <el-input v-model="ExtrasModel.LeadTrueName" autocomplete="off" placeholder="请输入审核人姓名"></el-input>
          </el-form-item>
          <el-form-item label="审核人工号" :label-width="formLabelWidth" prop="LeadUserCode">
            <el-input v-model="ExtrasModel.LeadUserCode" autocomplete="off" placeholder="请输入审核人工号"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="OperExtrasModel">保存</el-button>
          <el-button @click="dialogVisible = false">取 消</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
import {
  ExtrasRelation,ExtrasRelationSave,GetExtrasRelation,DelExtrasRelation
} from "../../until/ZeusApiSDK/Logic/KPISettingLogic";
import {
  GetKnowledgeContentDescry,
  EncryptContent
} from "../../until/ZeusApiSDK/Logic/WikiLogic";
import {
  GetCurrentUserInfo,
  GetNewGuid
} from "../../until/ZeusApiSDK/Logic/HomeLogic";
import { Predicate } from "../../until/ZeusApiSDK/Model/Predicate.js";
    import { Decrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic";  
export default {
  data() {
    return {
      searchName:'',//搜索条件 Extras
      ExtrasList: [],
      pageSizes: [10, 20, 50, 100, 200],
      pageSize: 10,
      pageIndex: 1,
      totalCount: 0,
      loading: true,
      childrenOverdrafts: [],
      dialogVisible: false,
      dialogTitle: "添加模板",
      ExtrasModel: {},
      currentUser: {},
      rules: {
        //用户验证规则
        UserCode: [{ required: true, message: "请输入被考核人工号", trigger: "blur" }],
        TrueName: [{ required: true, message: "请输入被考核人姓名", trigger: "blur" }],
        LeadUserCode: [{ required: true, message: "请输入考核人工号", trigger: "blur" }],
        LeadTrueName: [{ required: true, message: "请输入考核人姓名", trigger: "blur" }]
      },
      formLabelWidth: "120px",
      currentRole:{},//当前登录用户角色
    };
  },
  created() {
    this.getCurrentUser();
    this.GetExtrasList();

    //获取当前用户角色
    this.getCurrentRole();
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetExtrasList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetExtrasList();
    },
    //搜索条件
    SearchByName: function() {
      this.pageIndex = 1;
      this.GetExtrasList();
    },
    Refresh:function(){
      this.GetExtrasList();
    },
    AddTask: function() {
      this.dialogTitle = "添加模板";
      this.dialogVisible = true;
      this.ExtrasModel = {};
    },
    UpdateExtras: function(row) {
      this.dialogTitle = "编辑模板";
      this.dialogVisible = true;
      GetExtrasRelation(row.Id).then(res => {
          console.log('res',res);
        if(res.Code==200){
            this.ExtrasModel = res.Data;
            // this.ExtrasModel.ExTrueName=res.Data.TrueName;
            // this.ExtrasModel.userCode=res.Data.UserCode;
        }else{
            this.ExtrasModel ={};
        }
      });
    },
    getCurrentUser: function() {
      this.currentUser = GetCurrentUserInfo();
    },
    //获取当前用户角色
    getCurrentRole:function(){
        var currentUserRole = window.sessionStorage.getItem("CurrentUserRole");
        this.currentRole = JSON.parse(Decrypt(currentUserRole));
    },
    DeleteExtras: function(row) {
      DelExtrasRelation(this.currentUser.UserCode,row.Id).then(res => {
          console.log('res',res);
          if(res.Code==200){
              this.$message({
                message: '删除成功',
                type: "success",
                center: true
              });
          }
          else{
              this.$message({
                message: res.Msg,
                type: "danger",
                center: true
              });
          }
          this.GetExtrasList();
      });
    },
    OperExtrasModel: function() {
      this.$refs["taskForm"].validate(valid => {
        if (valid) {
          if (this.ExtrasModel.Id) {
              //编辑
              this.ExtrasModel.ExuserCode=this.currentUser.UserCode;
              ExtrasRelationSave(this.ExtrasModel).then(res => {
                  if(res.Code==200){
                      this.$message({
                        message: '添加成功',
                        type: "success",
                        center: true
                      });
                      this.dialogVisible = false;
                      this.GetExtrasList();
                  }
                  else{
                      this.$message({
                        message: res.Msg,
                        type: "danger",
                        center: true
                      });
                  }
              });
          } 
          else {
              //添加
              this.ExtrasModel.ExuserCode=this.currentUser.UserCode;
              ExtrasRelationSave(this.ExtrasModel).then(res => {
                  if(res.Code==200){
                      this.$message({
                        message: '添加成功',
                        type: "success",
                        center: true
                      });
                      this.dialogVisible = false;
                      this.GetExtrasList();
                  }
                  else{
                      this.$message({
                        message: res.Msg,
                        type: "danger",
                        center: true
                      });
                  }
              });
          }
        }
      });
    },
    //获取绩效模板列表
    GetExtrasList: function() {
      this.loading = true;
      var userinfo = GetCurrentUserInfo();
      ExtrasRelation(
        this.pageIndex,
        this.pageSize,
        this.searchName
      ).then(pageRes => {
        if(pageRes.Code=200){
            this.ExtrasList=pageRes.Data.DataList;
            this.totalCount = pageRes.Data.totalCount;
            this.loading=false;
        }else{
            this.ExtrasList=[];
            this.totalCount = 0;
            this.loading=false;
        }
      });
    },
  }
};
</script>